import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const SearchMinus = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 9.99996H7.99999C7.39999 9.99996 6.99999 10.4 6.99999 11C6.99999 11.6 7.39999 12 7.99999 12H14C14.6 12 15 11.6 15 11C15 10.4 14.6 9.99996 14 9.99996ZM21.7 20.3L18 16.6C18.4 16.1 18.7 15.6 19 15.1C19.1 14.9 19.2 14.6 19.3 14.3V14.2C19.4 14 19.5 13.7 19.5 13.5C19.5 13.4 19.5 13.4 19.6 13.3C19.7 13.1 19.7 12.9 19.7 12.7C19.7 12.6 19.7 12.5 19.8 12.4C19.8 12.2 19.8 12.1 19.9 11.9C19.9 11.7 19.9 11.6 19.9 11.4C19.9 11.3 19.9 11.2 19.9 11.1C19.9 11.1 19.9 11.1 19.9 11C19.9 10.7 19.9 10.5 19.9 10.2V10.1C19.7 7.79996 18.5 5.49996 16.6 3.99996C12.7 0.79996 6.99999 1.39996 3.89999 5.29996C0.799994 9.19996 1.49999 14.9 5.29999 18C6.19999 18.7 7.19999 19.2 8.29999 19.6C8.29999 19.6 8.29999 19.6 8.39999 19.6C8.59999 19.7 8.89999 19.7 9.09999 19.8C9.19999 19.8 9.19999 19.8 9.29999 19.8C9.49999 19.8 9.79999 19.9 9.99999 19.9C10.1 19.9 10.1 19.9 10.2 19.9C10.5 19.9 10.8 19.9 11.1 19.9H11.2C11.4 19.9 11.7 19.9 11.9 19.9C12 19.9 12.2 19.9 12.3 19.8C12.4 19.8 12.5 19.8 12.6 19.7C12.8 19.7 12.9 19.6 13.1 19.6C13.2 19.6 13.2 19.6 13.3 19.5C13.5 19.4 13.7 19.4 13.9 19.3H14C15 19 15.9 18.5 16.6 17.8L20.3 21.5C20.7 21.9 21.3 21.9 21.7 21.5C22.1 21.3 22.1 20.7 21.7 20.3ZM11 18C7.09999 18 3.99999 14.9 3.99999 11C3.99999 7.09996 7.09999 3.99996 11 3.99996C14.9 3.99996 18 7.09996 18 11C18 14.9 14.9 18 11 18Z"
      fill="currentColor"
    />
  </svg>
)

export default SearchMinus
